import React from 'react';

const WorkPermitStep1Basic = ({ formData, handleChange, formErrors, permitTypes, statusOptions }) => {
  return (
    <div className="work-permit-step">
      <h3 className="form-section-title">1. Basic Information</h3>
      <div className="form-row">
        <div className="form-group">
          <label>Permit Type *</label>
          <select
            name="permitTypeId"
            value={formData.permitTypeId}
            onChange={handleChange}
            className={formErrors.permitTypeId ? 'error' : ''}
          >
            <option value="">Select type</option>
            {permitTypes.map((pt) => (
              <option key={pt.permitTypeId} value={pt.permitTypeId}>
                {pt.typeName}
              </option>
            ))}
          </select>
          {formErrors.permitTypeId && <span className="field-error">{formErrors.permitTypeId}</span>}
        </div>
        <div className="form-group">
          <label>Work Order # (optional)</label>
          <input
            type="text"
            name="workOrderId"
            value={formData.workOrderId}
            onChange={handleChange}
            placeholder="Link to a work order"
          />
        </div>
        <div className="form-group">
          <label>Status</label>
          <select name="status" value={formData.status} onChange={handleChange}>
            {statusOptions.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Valid From *</label>
          <input
            type="datetime-local"
            name="validFrom"
            value={formData.validFrom}
            onChange={handleChange}
            className={formErrors.validFrom ? 'error' : ''}
          />
          {formErrors.validFrom && <span className="field-error">{formErrors.validFrom}</span>}
        </div>
        <div className="form-group">
          <label>Valid To *</label>
          <input
            type="datetime-local"
            name="validTo"
            value={formData.validTo}
            onChange={handleChange}
            className={formErrors.validTo ? 'error' : ''}
          />
          {formErrors.validTo && <span className="field-error">{formErrors.validTo}</span>}
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Location</label>
          <input type="text" name="location" value={formData.location} onChange={handleChange} placeholder="Area / Building" />
        </div>
        <div className="form-group">
          <label>Specific Area</label>
          <input type="text" name="area" value={formData.area} onChange={handleChange} placeholder="Zone, floor, room" />
        </div>
      </div>

      <div className="form-group">
        <label>Work Description</label>
        <textarea
          name="workDescription"
          value={formData.workDescription}
          onChange={handleChange}
          placeholder="Briefly describe the job to be carried out"
        />
      </div>
    </div>
  );
};

export default WorkPermitStep1Basic;

